import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=09d8adde&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=09d8adde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d8adde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09d8adde')) {
      api.createRecord('09d8adde', component.options)
    } else {
      api.reload('09d8adde', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=09d8adde&scoped=true&", function () {
      api.rerender('09d8adde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2beRyns8jyT8q/JS/comp/DocBox.vue"
export default component.exports